import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { httpss } from '../utils/host';

export default function AccountAPI() {
  const [pages, setPages] = useState([]);
  const [callback, setCallback] = useState(false);

  const fetPage = async () => {
    await axios.get(`${httpss}/apis_v1/dashboard/page`)
    .then(response => {
      setPages(response.data);
      // console.log(response.data)
    })
    .catch(error => console.error('Error fetching data:', error));
  }
  useEffect(() => {
    fetPage()
  }, [callback]);

  return {
    pages: [pages,setPages],
    callback: [callback, setCallback]
  };
}
